import { render, staticRenderFns } from "./JTreeTable.vue?vue&type=template&id=028e0b12&scoped=true&"
import script from "./JTreeTable.vue?vue&type=script&lang=js&"
export * from "./JTreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e0b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028e0b12')) {
      api.createRecord('028e0b12', component.options)
    } else {
      api.reload('028e0b12', component.options)
    }
    module.hot.accept("./JTreeTable.vue?vue&type=template&id=028e0b12&scoped=true&", function () {
      api.rerender('028e0b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JTreeTable.vue"
export default component.exports